/**
 * Conturi contabile uzuale pentru deconturi — folosite ca optiuni de override
 * in editorul de linii cand categoria standard nu acopera cazul.
 * Valorile (cu analitica) sunt cele reale din EA, derivate din istoricul 542.
 */
export interface PlanCont {
  code: string
  label: string
}

export const PLAN_CONTURI: PlanCont[] = [
  { code: '6232.MK139', label: '6232.MK139 — Protocol prezentare (marketing)' },
  { code: '6232.08', label: '6232.08 — Protocol / marketing offline' },
  { code: '625', label: '625 — Deplasări, detașări, transferări' },
  { code: '6022.ded', label: '6022.ded — Combustibil deductibil' },
  { code: '628.01', label: '628.01 — Servicii diverse (parcare, spălătorie)' },
  { code: '604.d', label: '604.d — Materiale nestocate diverse' },
  { code: '604.r', label: '604.r — Rechizite, birotică' },
  { code: '4426', label: '4426 — TVA deductibilă' },
  { code: '401', label: '401 — Furnizori (facturi directe)' },
  { code: '626', label: '626 — Cheltuieli poștale / telecomunicații' },
]
